import { render, staticRenderFns } from "./FlyteSentDetails.vue?vue&type=template&id=176dde52"
import script from "./FlyteSentDetails.vue?vue&type=script&lang=js"
export * from "./FlyteSentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports